import { Session } from '../Models/session';

export const getSessionWeekDay: (session: Session, locale: string) => string = (
    session,
    locale,
) => {
    const dateStr = `${session.month}/${session.day}/${session.year}`;
    const date = new Date(dateStr);

    let day = date.toLocaleDateString('cs-Cz', { weekday: 'long' });
    day = day[0].toUpperCase() + day.slice(1, 2);

    return day;
};
